module.exports = __webpack_public_path__ + "media/home_hero-600.ed2db9b4.webm";